const MONTHS: Record<string, number> = {
  january: 0, february: 1, march: 2, april: 3, may: 4, june: 5,
  july: 6, august: 7, september: 8, october: 9, november: 10, december: 11,
};

export const validateDisplayDate = (
  input: string
): { ok: true; display: string } | { ok: false; reason: string } => {
  const normalized = input.replace(/\s+/g, " ").trim();
  if (!normalized) return { ok: false, reason: "Empty date" };

  // Matches e.g. "5 September 2025"
  const match = normalized.match(/^(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})$/);
  if (!match) return { ok: false, reason: "Use format like 14 May 2025" };

  const day = Number(match[1]);
  const monthName = match[2].toLowerCase();
  const year = Number(match[3]);

  if (!(monthName in MONTHS)) return { ok: false, reason: "Unknown month name" };
  if (year < 1900 || year > 2100) return { ok: false, reason: "Year out of range" };
  if (day < 1 || day > 31) return { ok: false, reason: "Day out of range" };

  const month = MONTHS[monthName];
  const d = new Date(Date.UTC(year, month, day));
  if (
    d.getUTCFullYear() !== year ||
    d.getUTCMonth() !== month ||
    d.getUTCDate() !== day
  ) {
    return { ok: false, reason: "Invalid calendar date" };
  }

  // Canonical display format
  const cap = (w: string) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
  return { ok: true, display: `${day} ${cap(monthName)} ${year}` };
};
